import { render, staticRenderFns } from "./CampoInput.vue?vue&type=template&id=2cbe2217&"
import script from "./CampoInput.vue?vue&type=script&lang=js&"
export * from "./CampoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports